import styles from './PageProgram.module.css'

function PageProgram() {
  return (
    <div className={styles.PageProgram}>
      <div className={styles.CodeAblazeTitle}>
        <h1>Our Program</h1>
      </div>
      <div className={styles.ContentDiv}>
        <div className={styles.DescriptionDiv}>
          Discover the key features that make our coding program exceptional. From hands-on curriculum to personalized guidance, we are committed to offering an enriching learning experience for every student.
          <br />
          <br />
        </div>
      </div>
      <div className={styles.ProgramFeatures}>
        <div className={styles.DivList}>
          <div>
            <div className={styles.ItemNum}>01</div>
            <div className={styles.ItemTitle}>Hands-On<br />Curriculum</div>
            <div className={styles.ItemContent}>In our program, students engage in a variety of computer science exercises to develop and apply their coding knowledge and enhance their problem-solving skills.</div>
          </div>
          <div>
            <div className={styles.ItemNum}>02</div>
            <div className={styles.ItemTitle}>Personalized<br />Learning</div>
            <div className={styles.ItemContent}>With several of our volunteers present for students to ask for help, our program caters to the individual learning needs of each student, ensuring personalized attention and growth.</div>
          </div>
          <div>
            <div className={styles.ItemNum}>03</div>
            <div className={styles.ItemTitle}>Enrichment & Self-<br />paced Content</div>
            <div className={styles.ItemContent}>We encourage persistence and exploration, providing guidance to confused students and enrichment opportunities such as personal projects to those with more experience.</div>
          </div>
        </div>
      </div>
      <br /><br /><br /><br />
    </div>
  );
}

export default PageProgram;
